import { createClient } from "@sanity/client";


export const client = createClient({

  projectId: "rt11628s",

  dataset: "production",

  useCdn: true,

  apiVersion: "2026-08-03",

});